// 🏙️ PÁGINA DE CIDADE (/vagas-em/palmas-pr, 03/11/2026).
//
// Esta é a MESMA regra do servidor (backend/Services/Vagas/CidadesDoMural.cs, método Interpretar, que usa
// Slugs.Gerar): "Cidade/UF" com UF real, sem acento, minúsculo, hífen, e a UF no fim. Ela existe dos dois
// lados porque a página da vaga monta o link sozinha, sem perguntar à API. Se uma das duas mudar e a outra
// não, o link "Mais vagas em" passa a levar a uma página que não existe. Mexeu aqui, mexa lá.

const UFS = new Set(["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"]);

/** "Palmas/PR" → { slug: "palmas-pr", nome: "Palmas", uf: "PR", caminho: "/vagas-em/palmas-pr" }, ou null. */
export function cidadeDaVaga(cidade) {
  const c = String(cidade || "").trim();
  const barra = c.lastIndexOf("/");
  if (barra <= 0) return null;
  const nome = c.slice(0, barra).trim().replace(/\s{2,}/g, " ");
  const uf = c.slice(barra + 1).trim().toUpperCase();
  if (!UFS.has(uf) || nome.length < 2 || nome.toUpperCase() === uf) return null;
  if (!/\p{L}/u.test(nome) || nome.includes("/")) return null;
  const base = nome.toLowerCase().normalize("NFD").replace(/\p{Mn}/gu, "").normalize("NFC")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  if (!base) return null;
  const slug = `${base}-${uf.toLowerCase()}`;
  return { slug, nome, uf, caminho: `/vagas-em/${slug}` };
}
